import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { can } from '../utils/permissions'

export const Can = props => {
  const { children, functionality = '', permissions = [] } = props
  return can(`${functionality}`, permissions) || !functionality ? children : null
}

const mapStateToProps = state => ({
  permissions: state.auth.permissions
})

export default connect(mapStateToProps, null)(withRouter(Can))



// WEBPACK FOOTER //
// ./src/components/Can.js